import { Button, ButtonVariant, Grid } from '@focaldata/cin-ui-components'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useStyles } from '.'
import {
  useGetSoftLaunchOrder,
  useGetSurveyOrder
} from '../../../components/SoftLaunch'
import { SurveyParams } from '../../../data/model/surveyParams'
import { FullLaunchDialogContainer } from '../FullLaunchDialog'
import { useFullLaunch } from './useFullLaunch'

interface Props {
  /** Paused survey — the launch resumes it. */
  isPaused?: boolean
}

const FullLaunchButtonContainer: React.FC<Props> = ({ isPaused = false }) => {
  const params = useParams<keyof SurveyParams>()
  // @todo Legacy eslint violation – fix this when editing
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const surveyId = params.surveyId!
  const { classes } = useStyles()

  const [isFullLaunchDialogOpen, setIsFullLaunchDialogOpen] =
    useState<boolean>(false)
  const {
    remainingSamplesNeeded,
    samplesNeeded,
    isSurveyOrderLoading,
    isSoftLaunchOrder,
    isFullLaunchOrder
  } = useGetSoftLaunchOrder()
  const { panelSupplierOrders } = useGetSurveyOrder()

  const { confirmFullLaunch, isPlacingOrder, isOrderPlaced } = useFullLaunch({
    surveyId,
    // The supplier comes from the existing (soft-launch) order.
    panelSupplierCode: panelSupplierOrders?.[0]?.panelSupplierCode,
    samplesNeeded,
    remainingSamplesNeeded,
    isPaused,
    onCompleted: () => setIsFullLaunchDialogOpen(false)
  })

  const isFullLaunchProcessing =
    isPlacingOrder || isSurveyOrderLoading || isOrderPlaced
  const buttonText = 'Full launch'
  const isOrderNotPlacedYet = !isOrderPlaced && !isFullLaunchOrder

  return isSoftLaunchOrder && isOrderNotPlacedYet ? (
    <Grid item xs="auto" className={classes.fullLaunch}>
      <Button
        disabled={isFullLaunchProcessing || isFullLaunchDialogOpen}
        variant={ButtonVariant.PrimaryFilled}
        onClick={() => setIsFullLaunchDialogOpen(true)}
        style={{ marginRight: '10px' }}
      >
        {buttonText}
      </Button>
      <FullLaunchDialogContainer
        showDialog={isFullLaunchDialogOpen}
        toggleOpenDialog={setIsFullLaunchDialogOpen}
        onConfirm={confirmFullLaunch}
        isPlacingOrder={isPlacingOrder}
      />
    </Grid>
  ) : null
}

export default FullLaunchButtonContainer
